import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { TextTemplateType } from '@shared/enums/TextTemplateType';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { ITextTemplate } from '@shared/services/api/legacy/templates-service/template-model';
import { TextTemplate } from '@routes/templates/models/template-model';

@Injectable()
export class TemplatesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${TemplatesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/templates';

    public getTextTemplate(type: TextTemplateType): Observable<SuccessResponse<ITextTemplate> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<ITextTemplate>>(TemplatesService.URL + '/text/' + type).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateTextTemplate(template: TextTemplate): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(TemplatesService.URL + '/text', template).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
